<script>
export default {
    functional: true,
    props: {
        column: {
            type: null,
            default: null
        },
        data: {
            type: null,
            default: null
        },
        index: {
            type: Number,
            default: null
        },
        type: {
            type: String,
            default: null
        }
    },
    render(createElement, context) {
        const content = context.props.column.$scopedSlots[context.props.type]({
            'data': context.props.data,
            'index': context.props.index,
            'column': context.props.column
        });
        return [content];
    }
}
</script>


// WEBPACK FOOTER //
// ColumnSlot.vue?44550632